export class UserFormModel {

  public iHash: string = null;
  public username: string = null;
  public firstname: string = null;
  public lastname: string = null;
  public password: string = null;
  public password_confirmation: string = null;
  public email: string = null;
  public email_confirmation: string = null;

  /**
   * Constructor
   *
   * @param user
   */
  public constructor(user: {firstname: string, lastname: string, iHash: string, email: string, username: string} = null) {
    if (user) {
      this.firstname = user.firstname;
      this.lastname = user.lastname;
      this.iHash = user.iHash;
      this.email = user.email;
      this.username = user.username;
    }
  }
}
